import {
  WSCard,
  WSControlGroup,
  WSForm,
  WSIconList,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { WSCardProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCard";
import {
  GeneralLiabilityAggregateMinimum,
  GeneralLiabilityPerOccurrenceMinimum
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import { getLimitOptions } from "./getLimitOptions";

const GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUMS: GeneralLiabilityPerOccurrenceMinimum[] =
  [500000, 1000000, 2000000, 5000000];
const GENERAL_LIABILITY_AGGREGATE_MINIMUMS: GeneralLiabilityAggregateMinimum[] =
  [1000000, 2000000, 3000000, 5000000];

export const GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUM_COMMON: GeneralLiabilityPerOccurrenceMinimum = 1000000;
export const GENERAL_LIABILITY_AGGREGATE_MINIMUM_COMMON: GeneralLiabilityAggregateMinimum = 2000000;

const PER_OCCURRENCE_LIMIT_MINIMUM_OPTIONS = getLimitOptions(
  GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUMS,
  GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUM_COMMON
);

const AGGREGATE_LIMIT_MINIMUM_OPTIONS = getLimitOptions(
  GENERAL_LIABILITY_AGGREGATE_MINIMUMS,
  GENERAL_LIABILITY_AGGREGATE_MINIMUM_COMMON
);

export const FormPartialGeneralLiability: React.FC<WSCardProps> = props => (
  <WSCard {...props}>
    <WSSectionToolbar title="Your requirements for uploaded insurance" />

    <WSList gap="L" mt="L">
      <WSForm.Field
        name="coverageType"
        component={WSControlGroup}
        label="Policy type"
        componentProps={{
          type: "radio",
          size: "S",
          required: true,
          helperText: "Select one",
          chip: true,
          options: [
            {
              value: "occurrence",
              label: (
                <>
                  <b>Occurrence only</b> (most common) - Covers incidents during
                  the policy period, regardless of when claims are filed
                </>
              )
            },
            {
              value: "claimsMade",
              label: (
                <>
                  <b>Accept claims-made too</b> - Also accept policies that only
                  cover claims filed during the policy period
                </>
              )
            }
          ]
        }}
      />

      <WSForm.Field
        name="perIncidentLimitMinimum"
        label="Per-incident limit (minimum)"
        component={WSSelect}
        componentProps={{
          required: true,
          helperText: "Maximum paid for one incident (select one)",
          options: PER_OCCURRENCE_LIMIT_MINIMUM_OPTIONS
        }}
      />

      <WSForm.Field
        name="totalCoverageLimitMinimum"
        label="Total coverage limit (minimum)"
        component={WSSelect}
        componentProps={{
          required: true,
          helperText: "Maximum paid for all incidents in the policy year",
          options: AGGREGATE_LIMIT_MINIMUM_OPTIONS
        }}
      />

      <WSInfoBox
        theme="neutral"
        title="We automatically verify:"
        icon="shield-check-fill"
      >
        <WSIconList
          items={[
            "Valid COI format (not quotes or policy pages)",
            "Contractor name matches our records",
            "Coverage is currently active",
            "Correct policy type (occurrence vs claims-made)",
            "All limits meet your minimums"
          ]}
          iconProps={{
            name: "check-circle",
            color: "green500"
          }}
        />
      </WSInfoBox>
    </WSList>
  </WSCard>
);
